export const APP_NAME = 'LabGuard HQ';
export const APP_VERSION = '1.1.0';
